import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo_t from '../utils/echo_t.png';
import useDarkMode from './useDarkMode';

function Header() {
    const [theme, toggleTheme] = useDarkMode();
    const [expanded, setExpanded] = useState(false);
    const closeNav = () => setExpanded(false);

    const [visible, setVisible] = useState(true);

    const fwUser = localStorage.getItem('fw_user');
    const echoUser = localStorage.getItem('echo_user');
    const userLvl = Number(localStorage.getItem('fw_user_lvl') || 0);

    const admin = userLvl > 1;
    const isFwLogged = fwUser && fwUser !== "null" && fwUser !== "undefined";
    const isEchoLogged = echoUser && echoUser !== "null" && echoUser !== "undefined";
    const [msgCount, setMsgCount] = useState(0);
    const [notifCount, setNotifCount] = useState(0);

    useEffect(() => {
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            if (window.innerWidth > 991) return;

            if (window.scrollY < 10) {
                setVisible(true);
                return;
            }

            if (window.scrollY > lastScrollY + 10) {
                setVisible(false); // scroll dolů -> schovej
            } else if (window.scrollY < lastScrollY - 10) {
                setVisible(true); // scroll nahoru -> ukaž
            }

            lastScrollY = window.scrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const checkNewItems = async () => {
            if (!echoUser) return;

            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/check_updates.php", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user: echoUser })
                });
                const data = await res.json();

                if (data.status === 'success') {
                    setMsgCount(data.messages || 0);
                    setNotifCount(data.notifications || 0);
                } else {
                    setMsgCount(0);
                    setNotifCount(0);
                }
            } catch (err) {
                console.error("Chyba při načítání nových zpráv/oznámení:", err);
            }
        };

        checkNewItems();
        const interval = setInterval(checkNewItems, 5000);

        return () => clearInterval(interval);
    }, [echoUser]);

    const navigate = useNavigate();

    return (
        <>
            <Navbar
                fixed="top"
                bg="danger"
                className={`p-2 transition-navbar ${visible ? 'navbar-visible' : 'navbar-hidden'}`}
                variant="dark"
                expand="lg"
                expanded={expanded}
            >
                <Container>
                    <Navbar.Brand title="Načíst stránku znovu" href="/">
                        <img style={{ maxHeight: "50px" }} src={logo_t} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {isFwLogged ? (
                                <>
                                    {isEchoLogged ? (
                                        <>
                                            <Nav.Link className="text-light" onClick={() => { closeNav(); navigate('/'); }}>
                                                <i className="bi bi-house-door-fill"></i> Timeline
                                            </Nav.Link>
                                            <Nav.Link className="text-light" onClick={() => { closeNav(); navigate('/profile'); }}>
                                                <i className="bi bi-person-circle"></i> Profil
                                            </Nav.Link>
                                            <Nav.Link className="text-light position-relative" onClick={() => { closeNav(); navigate('/chat'); }}>
                                                <i className="bi bi-chat-dots-fill"></i>
                                                {msgCount > 0 && (
                                                    <span className="position-absolute top-0 translate-middle badge rounded-pill bg-warning text-dark">
                                                        {msgCount}
                                                    </span>
                                                )}
                                                <span className="ms-1">Zprávy</span>
                                            </Nav.Link>
                                            <Nav.Link className="text-light position-relative" onClick={() => { closeNav(); navigate('/notifications'); }}>
                                                <i className="bi bi-bell-fill"></i>
                                                {notifCount > 0 && (
                                                    <span className="position-absolute top-0 translate-middle badge rounded-pill bg-warning text-dark">
                                                        {notifCount}
                                                    </span>
                                                )}
                                                <span className="ms-1">Oznámení</span>
                                            </Nav.Link>
                                            <NavDropdown title={<span className="text-light"><i className="bi bi-menu-app-fill"></i> Další</span>} id="basic-nav-dropdown">
                                                <NavDropdown.Item className="text-dark" onClick={() => { closeNav(); navigate('/char'); }}>
                                                    <i className="bi bi-people-fill"></i> Přepnout účet
                                                </NavDropdown.Item>
                                                <NavDropdown.Item className="text-dark" onClick={() => { closeNav(); navigate('/settings'); }}>
                                                    <i className="bi bi-gear-wide-connected"></i> Nastavení
                                                </NavDropdown.Item>
                                                {admin && (
                                                    <>
                                                        <NavDropdown.Item className="text-dark" onClick={() => { closeNav(); navigate('/boost'); }}>
                                                            <i className="bi bi-heart-fill"></i> Boost
                                                        </NavDropdown.Item>
                                                        <NavDropdown.Item className="text-dark" onClick={() => { closeNav(); navigate('/admin'); }}>
                                                            <i className="bi bi-person-fill-gear"></i> Admin
                                                        </NavDropdown.Item>
                                                    </>
                                                )}
                                                <NavDropdown.Item className="text-dark" onClick={() => { closeNav(); navigate('/logout'); }}>
                                                    <i className="bi bi-door-closed-fill"></i> Odhlásit FW
                                                </NavDropdown.Item>
                                            </NavDropdown>
                                        </>
                                    ) : (
                                        <>
                                            <Nav.Link className="text-light" onClick={() => { closeNav(); navigate('/char'); }}>
                                                <i className="bi bi-people-fill"></i> Vybrat postavu
                                            </Nav.Link>
                                            <Nav.Link className="text-light" onClick={() => { closeNav(); navigate('/logout'); }}>
                                                <i className="bi bi-door-closed-fill"></i> Odhlásit FW
                                            </Nav.Link>
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Nav.Link className="text-light" onClick={() => { closeNav(); navigate('/login'); }}>
                                        <i className="bi bi-box-arrow-in-right"></i> Přihlásit
                                    </Nav.Link>
                                </>
                            )}
                        </Nav>
                        <Nav className="ms-auto">
                            <Nav.Link className="text-light" onClick={toggleTheme}>
                                {theme === 'dark' ? (
                                    <><i className="bi text-warning bi-sun-fill"></i> Světlý režim</>
                                ) : (
                                    <><i className="bi text-muted bi-moon-fill"></i> Tmavý režim</>
                                )}
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default Header;
